import React, { useState } from "react";
import { getIconHuay } from "../helper/Colorhuaycard";
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';

const ResultHuayCardNormal = (props) => {
  const ResultBox = (props) => (
    <div className="grid grid-cols-1 bg-[#f8eede] text-[#b3853e]">
      <div className="w-full text-base text-center pt-2">
        {props.name}
      </div>
      <div className="w-full text-2xl text-center font-bold pt-1 pb-2">
        {props.number}
      </div>
    </div>
  );

  return (
    <div className="w-auto h-auto rounded border mt-2 mx-1 shadow border-[#b3853e]">
      <div
        className="flex px-2 text-[#f8eede] rounded-t py-1 bg-gradient-to-t from-[#b3853e] to-[#b3853e]"
      >
        <div className="mt-2 w-auto pr-1">
          <img src={getIconHuay(props.lotteryName)} layout={"fixed"} width={26} height={26} />
        </div>
        <span className="text-sm mt-3 font-semibold pr-1">ผล{props.lotteryName} - </span>
        <span className="text-sm mt-3 font-semibold">{new Date(props.result[0]?.roundDate ? props.result[0]?.roundDate : props.date).toLocaleDateString('th-TH')}</span>
      </div>
      <div className="grid grid-cols-2 border-b rounded">

        <div className="col-span-1 border-[#b3853e] ">
          <ResultBox name="3 ตัวบน" number={props.result[0]?.results.find(data => data.betType == 'bon_3') ? props.result[0]?.results.find(data => data.betType == 'bon_3').betNumber : "xxx"} />
        </div>
        <div className="col-span-1 border-l border-[#b3853e]">
          <ResultBox name="2 ตัวล่าง" number={props.result[0]?.results.find(data => data.betType == 'lang_2') ? props.result[0]?.results.find(data => data.betType == 'lang_2').betNumber : "xx"} />
        </div>
        {/* <div className="col-span-1 border-r border-[#b3853e]">
          <ResultBox name="4 ตัวบน" number={props.result[0]?.results.filter(data => data.betType == 'bon_4').length ? props.result[0]?.results.filter(data => data.betType == 'bon_4').map(data => (data.betNumber + " ")) : "xxxx"} />
        </div> */}
      </div>
    </div>
  );
};

const ResultHuayCardThai = (props) => {
  // console.log(props)
  const ResultBox = (props) => (
    <div className="grid grid-cols-1 bg-[#f8eede] text-[#b3853e]">
      <div className="w-full text-base text-center pt-2">
        {props.name}
      </div>
      <div className="w-full text-2xl text-center font-bold pt-1 pb-2">
        {props.number}
      </div>
    </div>
  );
  return (
    <div className="w-auto h-auto rounded border mt-2 mx-1 shadow border-[#b3853e]">
      <div
        className="flex px-2 text-[#f8eede] rounded-t py-1 bg-gradient-to-t from-[#b3853e] to-[#b3853e]"
      >
        <div className="mt-2 w-auto pr-1">
          <img src={getIconHuay(props.lotteryName)} layout={"fixed"} width={26} height={26} />
        </div>
        <span className="text-sm mt-3 font-semibold pr-1"> ผลหวยรัฐบาล - </span>
        <span className="text-sm mt-3 font-semibold">{new Date(props.result[0]?.roundDate ? props.result[0]?.roundDate : props.date).toLocaleDateString('th-TH')}</span>
      </div>
      <div className="grid grid-cols-3 ">
        <div className="col-span-3 border-b border-[#b3853e] ">
          <ResultBox name="รางวัลที่ 1" number={props.result[0]?.results.find(data => data.betType == '1prize') ? props.result[0]?.results.find(data => data.betType == '1prize').betNumber : "xxxxxx"} />
        </div>
        <div className="col-span-1 border-r border-[#b3853e]">
          <ResultBox name="2 ตัวล่าง" number={props.result[0]?.results.find(data => data.betType == 'lang_2') ? props.result[0]?.results.find(data => data.betType == 'lang_2').betNumber : "xx"} />
        </div>
        <div className="col-span-1 border-r border-[#b3853e]">
          <ResultBox name="3 ตัวหน้า" number={props.result[0]?.results.filter(data => data.betType == 'na_3').length ? props.result[0]?.results.filter(data => data.betType == 'na_3').map(data => (data.betNumber + " ")) : "xxx xxx"} />
        </div>
        <div className="col-span-1 border-r border-[#b3853e]">
          <ResultBox name="3 ตัวท้าย" number={props.result[0]?.results.filter(data => data.betType == 'lang_3').length ? props.result[0]?.results.filter(data => data.betType == 'lang_3').map(data => (data.betNumber + " ")) : "xxx xxx"} />
        </div>

      </div>
    </div>
  );
};
const ResultHuayCardJackPot = (props) => {
  // console.log(props)
  const ResultBox = (props) => (
    <div className="grid grid-cols-1 bg-[#f8eede]  text-[#b3853e]">
      <div className="w-full text-base text-center pt-2">
        {props.name}
      </div>
      <div className="w-full text-2xl text-center font-bold pt-1 pb-2">
        {props.number}
      </div>
    </div>
  );
  return (
    <div className="w-auto h-auto rounded border mt-2 mx-1 shadow border-[#b3853e]">
      <div
        className="flex px-2 text-[#f8eede] rounded-t py-1 bg-gradient-to-t from-[#b3853e] to-[#b3853e]"
      >
        <div className="mt-2 w-auto pr-1">
          <img src={getIconHuay(props.lotteryName)} layout={"fixed"} width={26} height={26} />
        </div>
        <span className="text-sm mt-3 font-semibold pr-1"> ผล{props.lotteryName} - </span>
        <span className="text-sm mt-3 font-semibold">{new Date(props.result[0]?.roundDate ? props.result[0]?.roundDate : props.date).toLocaleDateString('th-TH')}</span>
      </div>
      <div className="grid grid-cols-2 ">
        <div className="col-span-2 border-b border-[#b3853e] ">
          <ResultBox name="รางวัลที่ 1" number={props.result[0]?.results.find(data => data.betType == 'bon_6') ? props.result[0]?.results.find(data => data.betType == 'bon_6').betNumber : "xxxxxx"} />
        </div>
        {props.lotteryName == 'หวยแจ็คพอต' &&
          <>
            <div className="col-span-1 border-r border-[#b3853e]">
              <ResultBox name="5 ตัวบน" number={props.result[0]?.results.filter(data => data.betType == 'bon_5').length ? props.result[0]?.results.filter(data => data.betType == 'bon_5').map(data => (data.betNumber + " ")) : "xxxxx"} />
            </div>
            <div className="col-span-1 border-r border-[#b3853e]">
              <ResultBox name="4 ตัวบน" number={props.result[0]?.results.filter(data => data.betType == 'bon_4').length ? props.result[0]?.results.filter(data => data.betType == 'bon_4').map(data => (data.betNumber + " ")) : "xxxx"} />
            </div>
          </>
        }
      </div>
    </div>
  );
};

const ResultHuayShare = (props) => {
  // console.log(props.result)
  const ResultBox = (props) => (
    <>
      <div className="grid grid-cols-4 bg-[#f8eede] border border-[#b3853e] mx-1 text-lg">
        <div className="col-span-2 px-5 text-lg flex justify-start">
          <div className="mt-0.5">
            <img src={getIconHuay(props.lotteryName)} layout={"fixed"} width={16} height={16} />
          </div>
          <span className="ml-2 mt-1 text-sm text-[#f8eede]">{props.name}</span>
        </div>
        <div className="border-l border-r border-[#b3853e] bg-[#f8eede] text-center">
          {props.number3}
        </div>
        <div className="bg-[#f8eede] text-center">{props.number2}</div>
      </div>
    </>
  );

  return (
    <div className="w-auto h-auto bg-[#f8eede] border rounded border-[#b3853e] mt-5 mx-1">
      <div className="flex justify-between bg-defaultColor px-2 text-[#f8eede]">
        <div className="grid grid-cols-7 gap-2">
          <div className="mt-2 w-auto">
            <img src={getIconHuay('หวยหุ้น')} layout={"fixed"} width={26} height={26} />
          </div>
          <span className="col-span-6 text-base mt-2 "> ผลหวยหุ้นต่างประเทศ</span>
        </div>

        <p className="bg-[#f8eede] rounded px-1 text-defaultText2 font-bold my-1 pt-1 text-base">
          {new Date(props.date).toLocaleDateString('th-TH')}
        </p>
      </div>
      <div className="grid grid-cols-4 text-center bg-defaultColor2 border border-[#b3853e] mt-1 mx-1 text-defaultText2 text-sm">
        <div className="col-span-2 text-defaultButtonLinkText">ประเภทห้วยหุ้น</div>
        <div className="border-l border-r border-[#b3853e] text-defaultButtonLinkText">3ตัวบน</div>
        <div className="text-defaultButtonLinkText">2ตัวล่าง</div>
      </div>

      <div className="pb-1">
        <ResultBox name="นิเคอิ(เช้า)" lotteryName="หวยหุ้นนิเคอิรอบเช้า"
          number3={props.result?.find(result => result?.lotteryName == "หวยหุ้นนิเคอิรอบเช้า")?.results.length ? props.result?.find(result => result?.lotteryName == "หวยหุ้นนิเคอิรอบเช้า")?.results.find(data => data?.betType == 'bon_3')?.betNumber : "xxx"}
          number2={props.result?.find(result => result?.lotteryName == "หวยหุ้นนิเคอิรอบเช้า")?.results.length ? props.result?.find(result => result?.lotteryName == "หวยหุ้นนิเคอิรอบเช้า")?.results.find(data => data?.betType == 'lang_2')?.betNumber : "xx"} />
        <ResultBox name="จีน(เช้า)" lotteryName="หวยหุ้นจีนรอบเช้า"
          number3={props.result?.find(result => result?.lotteryName == "หวยหุ้นจีนรอบเช้า")?.results.length ? props.result?.find(result => result?.lotteryName == "หวยหุ้นจีนรอบเช้า")?.results.find(data => data?.betType == 'bon_3')?.betNumber : "xxx"}
          number2={props.result?.find(result => result?.lotteryName == "หวยหุ้นจีนรอบเช้า")?.results.length ? props.result?.find(result => result?.lotteryName == "หวยหุ้นจีนรอบเช้า")?.results.find(data => data?.betType == 'lang_2')?.betNumber : "xx"} />
        <ResultBox name="ฮั่งเส็ง(เช้า)" lotteryName="หวยหุ้นฮั่งเส็งรอบเช้า"
          number3={props.result?.find(result => result?.lotteryName == "หวยหุ้นฮั่งเส็งรอบเช้า")?.results.length ? props.result?.find(result => result?.lotteryName == "หวยหุ้นฮั่งเส็งรอบเช้า")?.results.find(data => data?.betType == 'bon_3')?.betNumber : "xxx"}
          number2={props.result?.find(result => result?.lotteryName == "หวยหุ้นฮั่งเส็งรอบเช้า")?.results.length ? props.result?.find(result => result?.lotteryName == "หวยหุ้นฮั่งเส็งรอบเช้า")?.results.find(data => data?.betType == 'lang_2')?.betNumber : "xx"} />
        <ResultBox name="ไต้หวัน" lotteryName="หวยหุ้นไต้หวัน"
          number3={props.result?.find(result => result?.lotteryName == "หวยหุ้นไต้หวัน")?.results.length ? props.result?.find(result => result?.lotteryName == "หวยหุ้นไต้หวัน")?.results.find(data => data?.betType == 'bon_3')?.betNumber : "xxx"}
          number2={props.result?.find(result => result?.lotteryName == "หวยหุ้นไต้หวัน")?.results.length ? props.result?.find(result => result?.lotteryName == "หวยหุ้นไต้หวัน")?.results.find(data => data?.betType == 'lang_2')?.betNumber : "xx"} />
        <ResultBox name="นิเคอิ(บ่าย)" lotteryName="หวยหุ้นนิเคอิรอบบ่าย"
          number3={props.result?.find(result => result?.lotteryName == "หวยหุ้นนิเคอิรอบบ่าย")?.results.length ? props.result?.find(result => result?.lotteryName == "หวยหุ้นนิเคอิรอบบ่าย")?.results.find(data => data?.betType == 'bon_3')?.betNumber : "xxx"}
          number2={props.result?.find(result => result?.lotteryName == "หวยหุ้นนิเคอิรอบบ่าย")?.results.length ? props.result?.find(result => result?.lotteryName == "หวยหุ้นนิเคอิรอบบ่าย")?.results.find(data => data?.betType == 'lang_2')?.betNumber : "xx"} />
        <ResultBox name="เกาหลี" lotteryName="หวยหุ้นเกาหลี"
          number3={props.result?.find(result => result?.lotteryName == "หวยหุ้นเกาหลี")?.results.length ? props.result?.find(result => result?.lotteryName == "หวยหุ้นเกาหลี")?.results.find(data => data?.betType == 'bon_3')?.betNumber : "xxx"}
          number2={props.result?.find(result => result?.lotteryName == "หวยหุ้นเกาหลี")?.results.length ? props.result?.find(result => result?.lotteryName == "หวยหุ้นเกาหลี")?.results.find(data => data?.betType == 'lang_2')?.betNumber : "xx"} />
        <ResultBox name="จีน(บ่าย)" lotteryName="หวยหุ้นจีนรอบบ่าย"
          number3={props.result?.find(result => result?.lotteryName == "หวยหุ้นจีนรอบบ่าย")?.results.length ? props.result?.find(result => result?.lotteryName == "หวยหุ้นจีนรอบบ่าย")?.results.find(data => data?.betType == 'bon_3')?.betNumber : "xxx"}
          number2={props.result?.find(result => result?.lotteryName == "หวยหุ้นจีนรอบบ่าย")?.results.length ? props.result?.find(result => result?.lotteryName == "หวยหุ้นจีนรอบบ่าย")?.results.find(data => data?.betType == 'lang_2')?.betNumber : "xx"} />
        <ResultBox name="ฮั่งเส็ง(บ่าย)" lotteryName="หวยหุ้นฮั่งเส็งรอบบ่าย"
          number3={props.result?.find(result => result?.lotteryName == "หวยหุ้นฮั่งเส็งรอบบ่าย")?.results.length ? props.result?.find(result => result?.lotteryName == "หวยหุ้นฮั่งเส็งรอบบ่าย")?.results.find(data => data?.betType == 'bon_3')?.betNumber : "xxx"}
          number2={props.result?.find(result => result?.lotteryName == "หวยหุ้นฮั่งเส็งรอบบ่าย")?.results.length ? props.result?.find(result => result?.lotteryName == "หวยหุ้นฮั่งเส็งรอบบ่าย")?.results.find(data => data?.betType == 'lang_2')?.betNumber : "xx"} />
        <ResultBox name="สิงคโปร์" lotteryName="หวยหุ้นสิงคโปร์"
          number3={props.result?.find(result => result?.lotteryName == "หวยหุ้นสิงคโปร์")?.results.length ? props.result?.find(result => result?.lotteryName == "หวยหุ้นสิงคโปร์")?.results.find(data => data?.betType == 'bon_3')?.betNumber : "xxx"}
          number2={props.result?.find(result => result?.lotteryName == "หวยหุ้นสิงคโปร์")?.results.length ? props.result?.find(result => result?.lotteryName == "หวยหุ้นสิงคโปร์")?.results.find(data => data?.betType == 'lang_2')?.betNumber : "xx"} />
        <ResultBox name="อินเดีย" lotteryName="หวยหุ้นอินเดีย"
          number3={props.result?.find(result => result?.lotteryName == "หวยหุ้นอินเดีย")?.results.length ? props.result?.find(result => result?.lotteryName == "หวยหุ้นอินเดีย")?.results.find(data => data?.betType == 'bon_3')?.betNumber : "xxx"}
          number2={props.result?.find(result => result?.lotteryName == "หวยหุ้นอินเดีย")?.results.length ? props.result?.find(result => result?.lotteryName == "หวยหุ้นอินเดีย")?.results.find(data => data?.betType == 'lang_2')?.betNumber : "xx"} />
        <ResultBox name="อียิปต์" lotteryName="หวยหุ้นอียิปต์"
          number3={props.result?.find(result => result?.lotteryName == "หวยหุ้นอียิปต์")?.results.length ? props.result?.find(result => result?.lotteryName == "หวยหุ้นอียิปต์")?.results.find(data => data?.betType == 'bon_3')?.betNumber : "xxx"}
          number2={props.result?.find(result => result?.lotteryName == "หวยหุ้นอียิปต์")?.results.length ? props.result?.find(result => result?.lotteryName == "หวยหุ้นอียิปต์")?.results.find(data => data?.betType == 'lang_2')?.betNumber : "xx"} />
        <ResultBox name="รัสเซีย" lotteryName="หวยหุ้นรัสเซีย"
          number3={props.result?.find(result => result?.lotteryName == "หวยหุ้นรัสเซีย")?.results.length ? props.result?.find(result => result?.lotteryName == "หวยหุ้นรัสเซีย")?.results.find(data => data?.betType == 'bon_3')?.betNumber : "xxx"}
          number2={props.result?.find(result => result?.lotteryName == "หวยหุ้นรัสเซีย")?.results.length ? props.result?.find(result => result?.lotteryName == "หวยหุ้นรัสเซีย")?.results.find(data => data?.betType == 'lang_2')?.betNumber : "xx"} />
        <ResultBox name="อังกฤษ" lotteryName="หวยหุ้นอังกฤษ"
          number3={props.result?.find(result => result?.lotteryName == "หวยหุ้นอังกฤษ")?.results.length ? props.result?.find(result => result?.lotteryName == "หวยหุ้นอังกฤษ")?.results.find(data => data?.betType == 'bon_3')?.betNumber : "xxx"}
          number2={props.result?.find(result => result?.lotteryName == "หวยหุ้นอังกฤษ")?.results.length ? props.result?.find(result => result?.lotteryName == "หวยหุ้นอังกฤษ")?.results.find(data => data?.betType == 'lang_2')?.betNumber : "xx"} />
        <ResultBox name="เยอรมัน" lotteryName="หวยหุ้นเยอรมัน"
          number3={props.result?.find(result => result?.lotteryName == "หวยหุ้นเยอรมัน")?.results.length ? props.result?.find(result => result?.lotteryName == "หวยหุ้นเยอรมัน")?.results.find(data => data?.betType == 'bon_3')?.betNumber : "xxx"}
          number2={props.result?.find(result => result?.lotteryName == "หวยหุ้นเยอรมัน")?.results.length ? props.result?.find(result => result?.lotteryName == "หวยหุ้นเยอรมัน")?.results.find(data => data?.betType == 'lang_2')?.betNumber : "xx"} />
        <ResultBox name="ดาวโจนส์" lotteryName="หวยหุ้นดาวน์โจน"
          number3={props.result?.find(result => result?.lotteryName == "หวยหุ้นดาวน์โจน")?.results.length ? props.result?.find(result => result?.lotteryName == "หวยหุ้นดาวน์โจน")?.results.find(data => data?.betType == 'bon_3')?.betNumber : "xxx"}
          number2={props.result?.find(result => result?.lotteryName == "หวยหุ้นดาวน์โจน")?.results.length ? props.result?.find(result => result?.lotteryName == "หวยหุ้นดาวน์โจน")?.results.find(data => data?.betType == 'lang_2')?.betNumber : "xx"} />
      </div>
    </div>
  );
};

const ResultHuayYeekee = (props) => {
  const [index, setIndex] = useState(1)
  const [subIndex, setSubIndex] = useState(0)
  // console.log(props)
  const ResultBox = (props) => {
    return (<>
      <div className="grid grid-cols-4 border bg-[#f8eede] border-[#b3853e] mx-1 text-[#f8eede] text-sm">
        <div
          className="col-span-2 text-center bg-gradient-to-t from-[#b3853e] to-[#b3853e] "
        >
          {props.name}
        </div>
        <div
          className="border-l border-r border-[#b3853e] text-center text-[#b3853e]"
        >
          {props.number3}
        </div>
        <div className="text-center text-[#b3853e]">{props.number2}</div>
      </div>
    </>)
  };

  const ResultBox2 = (props) => (
    <>
      <div className="grid grid-cols-2 mx-1 border-r border-b border-l rounded-b text-2xl font-bold text-[#b3853e] border-[#b3853e]">
        <div className="border-r text-center pt-1 pb-2 border-[#b3853e]">
          {props.number3}
        </div>
        <div className="text-center pt-1 pb-2">{props.number2}</div>
      </div>
    </>
  )

  return (
    <div className="w-auto h-auto bg-[#f8eede] border border-[#b3853e] rounded mt-2 mx-1">
      <div
        className="flex px-2 text-[#f8eede] rounded-t py-1 bg-gradient-to-t from-[#b3853e] to-[#b3853e]"
      >
        <div className="mt-2 w-auto pr-1">
          <img src={getIconHuay(props.lotteryName)} layout={"fixed"} width={26} height={26} />
        </div>
        <span className="text-base mt-2 pr-1">ผล{props.lotteryName} - </span>
        <span className="text-base mt-2">{new Date(props.result[0]?.roundDate ? props.result[0]?.roundDate : props.date).toLocaleDateString('th-TH')}</span>
      </div>
      <div className="grid grid-cols-2 text-center text-[#b3853e] gap-2 mx-2 text-sm my-1">
        <button
          onClick={() => setIndex(0)}
          className={`w-full border py-2 rounded border-[#b3853e] ${index === 0 && `bg-gradient-to-t from-[#b3853e] to-[#b3853e] text-[#f8eede]`}`}

        >
          มุมมองยาว
        </button>
        <button
          onClick={() => setIndex(1)}
          className={`w-full border py-2 rounded border-[#b3853e] ${index === 1 && `bg-gradient-to-t from-[#b3853e] to-[#b3853e] text-[#f8eede]`}`}
        >
          มุมมองสั้น
        </button>
      </div>
      {index == 0 ?
        <div id="yeekee1">
          <div
            className="grid grid-cols-4 text-center border border-[#b3853e] mx-1 text-defaultText2 text-lg bg-gradient-to-t from-[#b3853e] to-[#b3853e]"
          >
            <div className="col-span-2 text-defaultButtonLinkText">รอบ</div>
            <div className="border-l border-r border-[#b3853e] text-defaultButtonLinkText">3 ตัวบน</div>
            <div className="text-defaultButtonLinkText">2 ตัวบน</div>
          </div>
          <div className="pb-1">
            {props.result.map((data, i) => (
              <ResultBox key={i} name={`จับยี่กี รอบที่${i + 1}`}
                number3={data.results.length ? data?.results.find(result => result?.betType == 'bon_3')?.betNumber : 'xxx'}
                number2={data.results.length ? data?.results.find(result => result?.betType == 'bon_2')?.betNumber : 'xx'} />))}
          </div>
        </div> :
        <div id="yeekee2">
          {props.result.map((data, i) => (
            subIndex == i ?
              <div key={i} className={'py-1'}>
                <div
                  className="mx-1 flex justify-between w-auto text-[#f8eede] border-t border-r border-l rounded-t border-[#b3853e] text-center bg-gradient-to-t from-[#b3853e] to-[#b3853e]"

                >
                  <div className="py-1 ml-2">
                    <button onClick={() => setSubIndex(subIndex - 1)} className={`${subIndex == 0 ? 'hidden' : ''}`}>{<ArrowBackRoundedIcon />}</button>
                  </div>
                  <div className="text-base py-2">
                    จับยี่กี่ รอบที่ {i + 1}
                  </div>
                  <div className="py-1 mr-2">
                    <button onClick={() => setSubIndex(subIndex + 1)} className={`${subIndex == props.result.length - 1 ? 'hidden' : ''}`}>{<ArrowForwardRoundedIcon />}</button>
                  </div>
                </div>
                <div className="grid grid-cols-2 text-center mx-1 border-r border-l text-base text-[#b3853e] border-[#b3853e]">
                  <div className="border-r border-[#b3853e] pt-2">3 ตัวบน</div>
                  <div className="pt-2">2 ตัวบน</div>
                </div>
                <div className="pb-1">
                  <ResultBox2
                    number3={data.results.length ? data?.results.find(result => result?.betType == 'bon_3')?.betNumber : 'xxx'}
                    number2={data.results.length ? data?.results.find(result => result?.betType == 'bon_2')?.betNumber : 'xx'} />
                </div>
              </div> : <></>
          ))}
          <div className="grid grid-cols-8 text-center mx-1 mb-1 gap-1 text-sm ">
            {props.result.map((data, i) => (
              <button key={i} onClick={() => setSubIndex(i)} className={`rounded border  border-[#b3853e] py-1 ${subIndex == i ? 'bg-[#f8eede]  border-[#b3853e] text-[#b3853e]' : 'bg-[#b3853e] text-[#f8eede]'}`}>{i + 1}</button>
            ))}
          </div>
        </div>
      }
    </div>
  );
};

export default ResultHuayCardNormal;
export { ResultHuayCardThai, ResultHuayShare, ResultHuayYeekee, ResultHuayCardJackPot };
